export const QUESTIONS = [
  { key: 'skin', title: 'Hur skulle du beskriva din hud?', options: [['torr', 'Torr'], ['kombinerad', 'Kombinerad'], ['mogen', 'Mogen hud'], ['kanslig', 'Känslig']] },
  { key: 'concern', title: 'Vad vill du fokusera på?', options: [['glow', 'Lyster'], ['porer', 'Porer och hudton'], ['fasthet', 'Fasthet och fina linjer'], ['aterfuktning', 'Återfuktning']] },
  { key: 'goal', title: 'Hur omfattande vill du att rutinen ska vara?', options: [['enkel', 'Enkel rutin'], ['komplett', 'Komplett rutin'], ['verktyg', 'Rutin med hudvårdsverktyg']] },
  { key: 'budget', title: 'Vilken budget känns rätt?', options: [['under500', 'Under 500 kr'], ['500_1000', '500 – 1 000 kr'], ['over1000', 'Över 1 000 kr']] },
];
export const STEPS = [['cleanse', 'Rengör'], ['treat', 'Behandla'], ['hydrate', 'Återfukta'], ['protect', 'Skydda']];
export const STORAGE_KEY = 'nugina:saved-routine';

// Port of src/routes/quiz.tsx. Budget is a soft score per product, not a hard basket cap.
export function recommend(products, answers) {
  const cap = answers.budget === 'under500' ? 500 : answers.budget === '500_1000' ? 1100 : Infinity;
  const count = answers.goal === 'enkel' ? 2 : answers.goal === 'komplett' ? 4 : 5;
  const concerns = {
    glow: ['glow', 'serum', 'vitamin', 'pdrn', 'peptide', 'peptid'],
    porer: ['niacinamid', 'clarity', 'cleanser', 'foam', 'porer'],
    fasthet: ['calcium', 'kalcium', 'peptide', 'peptid', 'collagen', 'kollagen', 'device', 'ems'],
    aterfuktning: ['hyaluron', 'cream', 'moisturizer', 'kräm', 'balm', 'hydra'],
  };
  const skin = { torr: ['cream', 'kräm', 'balm', 'hyaluron'], kombinerad: ['niacinamid', 'serum', 'cleanser'], mogen: ['peptide', 'peptid', 'kollagen', 'calcium', 'kalcium', 'device'], kanslig: ['panthenol', 'cica', 'lugn', 'sensitive'] };
  return products.map((product) => {
    const type = (product.type || '').toLowerCase();
    const bag = `${type} ${product.title} ${(product.tags || []).join(' ')}`.toLowerCase();
    let score = (concerns[answers.concern] || []).reduce((sum, word) => sum + (bag.includes(word) ? 3 : 0), 0);
    score += (skin[answers.skin] || []).reduce((sum, word) => sum + (bag.includes(word) ? 2 : 0), 0);
    if ((product.scorePrice ?? product.price) / 100 > cap) score -= 5;
    const tool = type.includes('tool') || bag.includes('device') || bag.includes('ems');
    if (tool) score += answers.goal === 'verktyg' ? 4 : -3;
    if (product.available) score += 1;
    return { product, score };
  }).filter((item) => item.score > 0).sort((a, b) => b.score - a.score).slice(0, count).map((item) => item.product);
}

function node(tag, className, text) {
  const element = document.createElement(tag);
  if (className) element.className = className;
  if (text !== undefined) element.textContent = text;
  return element;
}
function safeUrl(value) {
  try {
    const url = new URL(value, window.location.origin);
    return ['http:', 'https:'].includes(url.protocol) ? url.href : '#';
  } catch { return '#'; }
}
function money(cents, catalog) {
  return new Intl.NumberFormat(catalog.locale || 'sv-SE', { style: 'currency', currency: catalog.currency || 'SEK' }).format(cents / 100);
}
function productCard(product, catalog) {
  const card = node('article', 'product-card');
  const link = node('a', 'product-card-image'); link.href = safeUrl(product.url);
  if (product.image) {
    const image = node('img'); image.src = safeUrl(product.image); image.alt = product.title; image.loading = 'lazy'; link.append(image);
  }
  const title = node('h3'); const titleLink = node('a', '', product.title); titleLink.href = safeUrl(product.url); title.append(titleLink);
  const meta = node('div', 'card-meta'); meta.append(title, node('p', 'price', money(product.price, catalog)));
  if (!product.available) meta.append(node('p', 'fine-print', 'Slutsåld'));
  card.append(link, meta); return card;
}
async function save(products, answers, source, scope, trigger) {
  const routine = {
    id: typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : `routine-${Date.now()}`,
    name: source === 'quiz' ? 'Min Hudanalys-rutin' : 'Min byggda rutin', source,
    skinType: answers.skin || null, concerns: answers.concern ? [answers.concern] : [],
    productHandles: products.map((product) => product.handle), savedAt: new Date().toISOString(), accountSaved: false,
  };
  const status = scope.querySelector('[data-routine-status]');
  if (trigger?.disabled) return;
  if (trigger) trigger.disabled = true;
  let localSaved = false;
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(routine)); localSaved = true; status.textContent = 'Rutinen är sparad på den här enheten. Den är ännu inte kopplad till ett kundkonto.'; }
  catch { status.textContent = 'Rutinen kunde inte sparas på enheten. Webbläsaren tillåter inte lokal lagring.'; }
  try {
    if (window.NuginaCustomer?.saveRoutine) {
      const accountSaved = await window.NuginaCustomer.saveRoutine(routine);
      if (accountSaved) {
        routine.accountSaved = true;
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(routine)); localSaved = true; } catch { /* Account save can succeed without local storage. */ }
        status.textContent = localSaved ? 'Rutinen är sparad på den här enheten och kopplad till ditt konto.' : 'Rutinen är sparad på ditt konto. Lokal lagring är inte tillgänglig.';
      }
    }
  } catch { status.textContent = localSaved ? 'Rutinen är sparad på den här enheten, men kunde inte kopplas till ditt konto. Försök igen.' : 'Rutinen kunde inte sparas. Försök igen.'; }
  finally { if (trigger) trigger.disabled = false; }
}
function results(products, catalog, scope, answers, source) {
  const region = node('div', 'routine-results');
  if (!products.length) { region.append(node('p', '', 'Inga produkter matchade just nu. Prova andra svar eller utforska sortimentet.')); return region; }
  const grid = node('div', 'product-grid'); products.forEach((product) => grid.append(productCard(product, catalog))); region.append(grid);
  const total = products.reduce((sum, product) => sum + product.price, 0);
  region.append(node('p', 'routine-total', `Produktpris totalt: ${money(total, catalog)}`));
  if (source === 'quiz') region.append(node('p', 'fine-print', 'Budgeten vägleder rekommendationen. Kontrollera totalbeloppet innan du handlar.'));
  const form = node('form', 'routine-actions');
  const localeRoot = document.documentElement.dataset.shopRoot || '/';
  form.action = `${localeRoot.replace(/\/?$/, '/')}cart/add`; form.method = 'post';
  form.setAttribute('data-cart-add', ''); form.setAttribute('data-cart-multi', '');
  products.forEach((product, index) => {
    for (const [key, value] of Object.entries({ id: product.variantId, quantity: 1 })) {
      const input = node('input'); input.type = 'hidden'; input.name = `items[${index}][${key}]`; input.value = value; form.append(input);
    }
  });
  const buy = node('button', 'button', 'Lägg rutinen i varukorgen →'); buy.type = 'submit'; buy.disabled = products.some((product) => !product.available);
  if (buy.disabled) region.append(node('p', 'fine-print', 'En produkt är slutsåld. Ändra ditt urval innan du lägger till hela rutinen.'));
  const saveButton = node('button', 'button button-outline', 'Spara min rutin'); saveButton.type = 'button'; saveButton.addEventListener('click', () => save(products, answers, source, scope, saveButton));
  const error = node('p', 'form-error'); error.setAttribute('data-form-error', ''); error.setAttribute('role', 'alert');
  form.append(buy, saveButton, error); region.append(form); return region;
}
function quiz(scope, catalog) {
  const panel = scope.querySelector('[data-quiz-panel]'); let step = 0; const answers = {};
  function render(focus = false) {
    panel.replaceChildren(); scope.querySelector('[data-routine-status]').textContent = '';
    const heading = node('h2', '', step < QUESTIONS.length ? QUESTIONS[step].title : 'Din personliga rutin'); heading.tabIndex = -1;
    panel.append(node('p', 'eyebrow', step < QUESTIONS.length ? `Fråga ${step + 1} av ${QUESTIONS.length}` : 'Din Nugina-rutin'), heading);
    if (step < QUESTIONS.length) {
      const question = QUESTIONS[step]; const choices = node('div', 'quiz-choices');
      for (const [value, label] of question.options) {
        const button = node('button', 'quiz-choice', label); button.type = 'button';
        button.setAttribute('aria-pressed', String(answers[question.key] === value));
        button.addEventListener('click', () => { answers[question.key] = value; step += 1; render(true); }); choices.append(button);
      }
      panel.append(choices);
    } else panel.append(results(recommend(catalog.products, answers), catalog, scope, answers, 'quiz'));
    if (step > 0) {
      const back = node('button', 'text-button', '← Tillbaka'); back.type = 'button'; back.addEventListener('click', () => { step -= 1; render(true); }); panel.append(back);
    }
    if (step === QUESTIONS.length) {
      const restart = node('button', 'text-button', 'Börja om'); restart.type = 'button'; restart.addEventListener('click', () => { step = 0; Object.keys(answers).forEach((key) => delete answers[key]); render(true); }); panel.append(restart);
    }
    if (focus) heading.focus();
  }
  render();
}
function builder(scope, catalog) {
  const steps = scope.querySelector('[data-builder-steps]'); const selections = new Map(); const output = scope.querySelector('[data-builder-result]');
  const update = () => {
    const products = [...new Set(selections.values())].map((handle) => catalog.products.find((product) => product.handle === handle)).filter(Boolean);
    output.replaceChildren(results(products, catalog, scope, {}, 'builder')); scope.querySelector('[data-routine-status]').textContent = '';
  };
  let matched = 0;
  for (const [key, label] of STEPS) {
    const products = catalog.products.filter((product) => product.step === key); matched += products.length;
    const group = node('div', 'builder-step'); const select = node('select'); const id = `Step-${scope.id || scope.closest('[id]')?.id || 'routine'}-${key}`; select.id = id;
    const labelNode = node('label', '', label); labelNode.htmlFor = id;
    select.append(new Option(products.length ? 'Välj produkt' : 'Inga produkter i detta steg ännu', ''));
    products.forEach((product) => { select.append(new Option(`${product.title} — ${money(product.price, catalog)}${product.available ? '' : ' — Slutsåld'}`, product.handle)); });
    select.disabled = !products.length;
    select.addEventListener('change', () => { if (select.value) selections.set(key, select.value); else selections.delete(key); update(); });
    group.append(labelNode, select); steps.append(group);
  }
  if (!matched) output.append(node('p', '', 'Produkter med rutinsteg är ännu inte tillgängliga. Utforska sortimentet eller prova hudanalysen.'));
}
export function initialize(root = document) {
  root.querySelectorAll('[data-skin-quiz], [data-routine-builder]').forEach((scope) => {
    if (scope.dataset.initialized) return;
    const script = scope.querySelector('[data-routine-catalog]');
    try {
      const catalog = JSON.parse(script.textContent); scope.dataset.initialized = 'true';
      if (scope.matches('[data-skin-quiz]')) {
        if (catalog.currency !== 'SEK') {
          scope.querySelector('[data-routine-status]').textContent = 'Hudanalysens budgetnivåer gäller svenska kronor. Välj butikens svenska marknad för att göra hudanalysen.';
        } else quiz(scope, catalog);
      } else builder(scope, catalog);
    } catch { scope.querySelector('[data-routine-status]').textContent = 'Produkterna kunde inte läsas in. Ladda om sidan och försök igen.'; }
  });
}
if (typeof document !== 'undefined') { initialize(); document.addEventListener('shopify:section:load', (event) => initialize(event.target)); }
